import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { clearErrorAvaliablePatients, fetchDoctorAvaliablePatients } from "../features/patientsToAssign/patientsToAssignSlice";
import { AssignPersons } from "../components/AssignPersons";
import { PageHeader } from "../components/PageHeader";
import { TableSkeleton } from "../components/TableSkeleton";
import { Person } from "../model/person";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { assingPatientsToDoctor, cancelAddPersonsToDoctor } from "../features/doctor/doctorSlice";
import { useTranslate } from "../i18n";
import { getErrorMessage } from "../utils/getErrorMessage";

export const AssignPatientsToDoctor = (
  props: {
    doctorId: string;
  }
) => {

  const dispatch = useAppDispatch();
  const t = useTranslate();
  const patients = useAppSelector((state) => state.patientsToAssign.patientsAvaliable);
  const status = useAppSelector((state) => state.patientsToAssign.status);
  const error = useAppSelector((state) => state.patientsToAssign.error);
  const navigate = useNavigate();

  const [isErrorDismissed, setIsErrorDismissed] = useState(false);

  useEffect(() => {
    //if (status == "idle") {
      dispatch(fetchDoctorAvaliablePatients(props.doctorId));
    //}
  },[]);

  const handleErrorOk = () => {
    setIsErrorDismissed(true);
    dispatch(clearErrorAvaliablePatients());
  }

  const handleAuthOk = () => {
    setIsErrorDismissed(true);
    navigate("/")
  }


  const onPatientsAssign = (persons: Person[]) => {
    dispatch(assingPatientsToDoctor({ doctorId: props.doctorId, patientIds: persons.map((person) => person.id) }));
  }

  const onCancel = () => {
    dispatch(cancelAddPersonsToDoctor());
  }


  if (status === "idle" || status === "loading") {
    return <>
      <PageHeader eyebrow={t("assign.eyebrow")} title={t("assign.patients.title")} />
      <TableSkeleton />
    </>;
  }

  if (status === "auth-error") {
    return <Modal
      title={t("auth.failed.title")}
      visible={!isErrorDismissed}
      onOk={handleAuthOk}
      okText={t("common.signIn")}
      cancelButtonProps={{ hidden: true }}
    >
      <p>{t("auth.failed.body")}</p>
    </Modal>
  }

  if (status === "error") {
    const errorMessage = getErrorMessage(error, t);
    return <Modal
      title={errorMessage.title}
      visible={!isErrorDismissed}
      onOk={handleErrorOk}
      cancelButtonProps={{ hidden: true }}
    >
      <p>{errorMessage.details}</p>
    </Modal>
  }

  return <AssignPersons
    title={t("assign.patients.title")}
    subtitle={t("assign.patients.forDoctor")}

    onPersonsAssign={onPatientsAssign}
    onCancel={onCancel}

    persons={patients.map(p => {
      return {
        id: p.id,
        firstName: p.firstName,
        lastName: p.lastName,
        phoneNumber: p.userAccount?.mobileNumber,
        email: p.userAccount?.emailAddress
      } as Person;
    })} />;
}
